import React from "react";
import {  Query, Loading } from "../../components";
import TestDescription from "./VPTDescription";
import TestStart from "./TestStart";
import { getVPTTest } from "../../lib/api";
// import LogRocket from 'logrocket';

// import setupLogRocketReact from 'logrocket-react';
// LogRocket.init('7khho1/edwisely_vpt');
// setupLogRocketReact(LogRocket);


const Test = ({
  match: {
    params: { tid, qid }
  }
}) => {
  return (
    <>
      <Query query={() => getVPTTest(tid)}>
        {({ loading, data }) => {
          if (loading) {
            return <Loading />;
          }
          if(data.status ==200){
            return !qid ? (
              <TestDescription {...data} {...{ tid }} />
            )  : (
              <TestStart {...data} {...{ tid, qid }}/>
            );
          }
          if(data.status==204){
            return <h3 style={{textAlign:'center',marginTop:'20px'}}>You have taken test already.</h3>
          }
        }}
      </Query>
    </>
  );
};

export default Test;
